module.exports = __webpack_public_path__ + "static/media/home-question.aaf16adb.jpg";